import { Box, SimpleGrid, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import {
  School,
  Lock,
  Cloud,
  FileText,
  Sliders,
  Layers,
  Users,
  Lightbulb
} from "lucide-react";

const EduvicUSP = () => {
  const iconColor = "blue.300";
  const textColor = "gray.200";
  const cardBg = "gray.800";

  const features = [
    {
      icon: School,
      title: "Multi-Tenant SaaS",
      description:
        "Onboard an organisation in minutes — with enrolment, courses, classes, batches, and assessments ready to configure."
    },
    {
      icon: Lock,
      title: "Secure & Role-Based Access",
      description:
        "Administrators, tutors, educators, and students each see the tools and information relevant to their role."
    },
    {
      icon: Cloud,
      title: "Cloud-Agnostic Content",
      description:
        "Google Drive integration today, with AWS S3 and additional content providers supported as the platform evolves."
    },
    {
      icon: FileText,
      title: "Serious Assessment Engine",
      description:
        "Multi-question-set exams, shuffled per attempt, with hybrid automatic and manual scoring built into the platform."
    },
    {
      icon: Sliders,
      title: "Flexible Scoring Models",
      description:
        "Weighted, normalized, and partial-credit scoring — configurable at the question-set level rather than bolted on afterwards."
    },
    {
      icon: Layers,
      title: "One Technology Foundation",
      description:
        "Eduvic Learning Platform supports structured learning programmes, while Eduvic Practice brings the same assessment technology directly to students."
    },
    {
      icon: Users,
      title: "Built Around Real Workflows",
      description:
        "Tutor marking queues, administrative controls, delegation, scheduled classes, and student workflows designed around how learning programmes actually operate."
    },
    {
      icon: Lightbulb,
      title: "Built In-House, End to End",
      description:
        "The platform, assessment engine, workflows, and product experience are designed and engineered by our own team."
    }
  ];

  return (
    <Box maxW="1200px" mx="auto" mt={2} >
      <Text
        fontSize={{ base: "2xl", md: "3xl" }}
        fontWeight="bold"
        textAlign="center"
        color={"cyan.200"}
        mb={8}
      >
        Our Pillars of Innovation
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
        {features.map((feature, index) => (
          <Box
            key={index}
            bg={cardBg}
            p={6}
            borderRadius="lg"
            boxShadow="md"
            textAlign="center"
          >
            <Icon as={feature.icon} boxSize={8} color={iconColor} mb={3} />
            <Text fontWeight="semibold" fontSize="lg" color={textColor} mb={2}>
              {feature.title}
            </Text>
            <Text fontSize="sm" color={textColor}>
              {feature.description}
            </Text>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default EduvicUSP;